import ComingSoon from "components/ComingSoon";
import React from "react";

const MongoDB = () => {
  return <ComingSoon />;
};

export default MongoDB;
